import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getTotalFamiliesAvailable from 'store/category/selector/getTotalFamiliesAvailable';
import getCategoryFilters from 'store/category/selector/getCategoryFilters';
import isFiltersEmpty from 'utils/family/isFiltersEmpty';
import prepareCategoryFilters from 'utils/family/prepareCategoryFilters';
import styles from './NoFilteringResults.module.scss';

const NoFilteringResults = () => {
  const { t } = useTranslation();
  const totalDesigns = useSelector(getTotalFamiliesAvailable);
  const currentFiltes = useSelector(getCategoryFilters);
  const filterringInProgress = !isFiltersEmpty(prepareCategoryFilters(currentFiltes));

  if (totalDesigns === 0 && filterringInProgress) {
    return <div className={styles.noResults}>{t('txt_filter_no_results')}</div>;
  }

  return null;
};

export default NoFilteringResults;
